var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointsCopper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 0-140 256 140 256 4.999-1.767c64.033-22.633 118.938-63.866 158.775-119.243 40.708-56.586 62.226-123.459 62.226-193.387v-133.337z",
    fill: "#d5750a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 64.266v133.337c0 69.929 21.518 136.802 62.226 193.388 39.838 55.377 94.742 96.61 158.775 119.243l4.999 1.766v-512z",
    fill: "#ea871e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.207 218.52c.525-6.928.793-13.904.793-20.918v-88.02l-166-47.203-110 156.141z",
    fill: "#ffd5a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 62.379-166 47.204v88.02c0 7.014.268 13.99.793 20.918h165.207z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 171.542-100 138.206 100 138.206 6.161-2.775c43.279-19.497 80.938-50.351 108.908-89.228 29.239-40.644 46.378-87.788 50.138-137.431z",
    fill: "#7e3a06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.793 218.52c3.76 49.643 20.899 96.787 50.139 137.431 27.969 38.877 65.628 69.73 108.907 89.228l6.161 2.775v-276.412z",
    fill: "#ac4f00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointsCopper);
export default __webpack_public_path__ + "static/media/PointsCopper.e5feed29167dc77c6066ccdda7c3d7bc.svg";
export { ForwardRef as ReactComponent };